import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'shared-rooted-device-dialog',
  templateUrl: './rooted-device-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class SharedRootedDeviceDialogComponent {
  private readonly dialogRef = inject<MatDialogRef<SharedRootedDeviceDialogComponent>>(MatDialogRef);

  dismiss(): void {
    this.dialogRef.close();
  }
}
